import { useEffect } from 'react';

export const useFilterCount = (
  key,
  count,
  onChange,
) => {
  useEffect(() => {
    if (typeof onChange === 'function') {
      onChange(key, count);
    }
  }, [key, count, onChange]);
};
